document.addEventListener('DOMContentLoaded', () => {
  // ----- Variant selection -----
  const form = document.getElementById('ackz-form');
  const sizeBtns = document.querySelectorAll('.size');
  const hiddenInput = document.getElementById('ackz-variant-id');

  if (sizeBtns && hiddenInput) {
    sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        sizeBtns.forEach(x => x.classList.remove('selected'));
        btn.classList.add('selected');
        hiddenInput.value = btn.getAttribute('data-variant') || '';
      });
    });
  }

  // ----- Prevent Add without size -----
  if (form && hiddenInput) {
    form.addEventListener('submit', (e) => {
      if (!hiddenInput.value) {
        e.preventDefault();
        alert('Please choose a size');
      }
    });
  }

  // ----- Open/close dialogs (size guide / measurements) -----
  const openers = {
    'size-guide': document.querySelectorAll('[data-open="size-guide"]'),
    'measurements': document.querySelectorAll('[data-open="measurements"]')
  };

  const dlgSize = document.getElementById('ackz-size-guide');
  const dlgMeas = document.getElementById('ackz-measure');

  (openers['size-guide'] || []).forEach(el => {
    el.addEventListener('click', () => {
      if (dlgSize && dlgSize.showModal) dlgSize.showModal();
    });
  });
  (openers['measurements'] || []).forEach(el => {
    el.addEventListener('click', () => {
      if (dlgMeas && dlgMeas.showModal) dlgMeas.showModal();
    });
  });

  document.querySelectorAll('dialog [data-close]').forEach(el => {
    el.addEventListener('click', () => {
      const dlg = el.closest('dialog');
      if (dlg) dlg.close();
    });
  });

  // ----- Simple pincode checker (mock) -----
  const pinBtn = document.getElementById('ackz-pin-check');
  const pinInp = document.getElementById('ackz-pin');
  const pinOut = document.getElementById('ackz-pin-result');

  if (pinBtn && pinInp && pinOut) {
    pinBtn.addEventListener('click', () => {
      const v = (pinInp.value || '').trim();
      if (v.length !== 6 || !/^\d{6}$/.test(v)) {
        pinOut.textContent = 'Enter a valid 6-digit pincode.';
        return;
      }
      // TODO: replace with your live API call if needed
      pinOut.textContent = 'Delivery ETA: 12–15 days';
    });
  }

  // ===== Mobile-only image carousel (≤ 989px) =====
  const isMobile = window.matchMedia('(max-width: 989px)').matches;
  if (isMobile) {
    const stack = document.querySelector('.ackz-col.gallery .stack');
    const slides = stack ? stack.querySelectorAll('.stack-item') : [];
    const pager = document.querySelector('.stack-pager');

    if (stack && slides.length > 1 && pager) {
      // Build dots
      slides.forEach((_s, i) => {
        const d = document.createElement('span');
        d.className = 'dot' + (i === 0 ? ' active' : '');
        d.dataset.index = String(i);
        pager.appendChild(d);
      });

      const dots = pager.querySelectorAll('.dot');

      // Helper: set active dot by index
      const setActive = (idx) => {
        dots.forEach((d, i) => d.classList.toggle('active', i === idx));
      };

      // Click a dot to go to slide
      dots.forEach(d => {
        d.addEventListener('click', () => {
          const idx = Number(d.dataset.index || 0);
          const x = idx * stack.clientWidth;
          stack.scrollTo({ left: x, behavior: 'smooth' });
          setActive(idx);
        });
      });

      // Update active dot on scroll
      let ticking = false;
      stack.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const idx = Math.round(stack.scrollLeft / stack.clientWidth);
          setActive(idx);
          ticking = false;
        });
      });

      // Resize observer to keep math correct on orientation/resize
      const ro = new ResizeObserver(() => {
        const idx = Math.round(stack.scrollLeft / stack.clientWidth);
        setActive(idx);
      });
      ro.observe(stack);
    }
  }
});

/* ===== ACK Zara PDP – header auto-hide / reveal (runs only on this PDP) ===== */
(function(){
  try {
    document.body.classList.add('ackz-pdp');

    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    const setHeaderH = () => {
      const h = header.offsetHeight || 64;
      document.documentElement.style.setProperty('--ackz-header-h', h + 'px');
    };
    setHeaderH();
    window.addEventListener('resize', setHeaderH);

    let lastY = window.scrollY || 0;
    let ticking = false;

    const onScroll = () => {
      const y = window.scrollY || 0;
      const goingDown = y > lastY;
      const shouldHide = goingDown && y > 80;
      document.body.classList.toggle('ackz-hide-header', shouldHide);
      lastY = y;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });

  } catch (e) {
    console.warn('ACK PDP header script error:', e);
  }
})();

/* ===== ACK Zara PDP – swap header logo on this template only (robust) ===== */
(function () {
  try {
    const hook = document.getElementById('ackz-alt-logo');
    if (!hook) return; // only on this PDP

    const altSrc = hook.dataset.src || '';
    const w = hook.dataset.width ? parseInt(hook.dataset.width, 10) : null;
    const h = hook.dataset.height ? parseInt(hook.dataset.height, 10) : null;
    if (!altSrc) return;

    // Attempt the swap against common Dawn/header variants
    const doSwap = (root = document) => {
      // Find the clickable logo link container first
      const link =
        root.querySelector('.header__heading .header__heading-link') ||
        root.querySelector('a.header__heading-link') ||
        root.querySelector('.header__heading-logo') ||
        root.querySelector('.header__heading') ||
        null;

      if (!link) return false;

      // If there is any <img> inside (including <picture>), update it
      let img = link.querySelector('picture img') || link.querySelector('img');

      if (img) {
        if (!img.dataset.origSrc) {
          img.dataset.origSrc = img.getAttribute('src') || '';
          img.dataset.origSrcset = img.getAttribute('srcset') || '';
        }
        img.setAttribute('src', altSrc);
        img.removeAttribute('srcset'); // prevent old responsive picks
        if (w) img.setAttribute('width', String(w));
        if (h) img.setAttribute('height', String(h));
        if (h) img.style.height = h + 'px';
        if (w) img.style.width = w + 'px';
      } else {
        // No <img> (likely SVG/text). Replace contents with our image.
        const newImg = document.createElement('img');
        newImg.src = altSrc;
        if (w) newImg.width = w;
        if (h) newImg.height = h;
        newImg.alt = 'Logo';
        link.innerHTML = '';
        link.appendChild(newImg);
      }

      document.documentElement.classList.add('ackz-logo-swapped');
      return true;
    };

    // Try immediately
    if (doSwap()) return;

    // If header hydrates later, observe and try again until success
    const obs = new MutationObserver(() => {
      if (doSwap()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Safety retries (covers very late hydration)
    setTimeout(() => doSwap(), 600);
    setTimeout(() => doSwap(), 1200);
  } catch (e) {
    console.warn('ACK PDP logo swap error:', e);
  }
})();

